import { SearchActivityResult } from '@types';

const RESULT_MAP: Record<SearchActivityResult, string> = {
  match: 'Match',
  noMatch: 'No match',
  error: 'Error',
};

export default RESULT_MAP;
